



import MemberEditComponent from "@/components/admin/member/memberEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberEditPage",
  components: {
    MemberEditComponent,
  },
})
export default class MemberEditPage extends Vue {}
